(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxSetupAuthentication(
    $filter, $http, URLS, $location,
    $window, TenantListService, NetworkListService,
    IDP_PROVIDERS
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        me: '=me',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/authenticationSettings/setupAuthentication/setupAuthentication.template.html',
      link: function(scope) {

        scope.idpDescriptors = IDP_PROVIDERS;
        scope.signInMethodMap = {};
        scope.adEnabled = false;
        scope.ad = null;
        scope.idProviderEnabled = false;
        scope.buildIn = null;
        scope.buildInEnabled = false;
        scope.todoMap = {};
        scope.ActiveDirectory = $filter('translate')('ActiveDirectory');
        scope.adNetwork = null;

        (function() {
          scope.todoMap = TenantListService.currentTenant.info.todoMap;
          mapSignInMethods()
          checkAD();
          checkBuildIn();
          setListeners();
          watchTheTodos();
        })();


        function watchTheTodos () {

          scope.$watch(function () {
            return TenantListService.currentTenant.info._embedded.toDos
          }, function (val1, val2) {
            if (val1 !== val2) {
              checkTodoList();
            }
          })

        }

        function checkTodoList () {
          scope.todoMap = TenantListService.currentTenant.info.todoMap;
        }

        function mapSignInMethods () {
          const providers = scope.tenant.info._embedded.tenantIdentityProviders.providers;
          const unorderedMap = {}
          for (const key in providers) {
            unorderedMap[key] = [];
            if (Object.keys(providers[key].directories).length > 0) {
              for (const directory in providers[key].directories) {
                unorderedMap[key].push(providers[key].directories[directory])
                scope.idProviderEnabled = true;
              }
            }
          }


          scope.signInMethodMap = Object.keys(unorderedMap).sort().reduce(
            (obj, key) => {
              obj[key] = unorderedMap[key];
              return obj;
            },
            {}
          );

        }

        function checkAD () {
          const ad = scope.ad = scope.tenant.info._embedded.authenticationConfiguration.ad;

          if (ad.enabled && ad.defaultDomain && ad.network && ad.port && ad.server) {
            scope.adEnabled = true;
            getAD_NetworkToScope(ad)
          } else {
            scope.adEnabled = false;
          }
        }

        function getAD_NetworkToScope (ad) {
          if (ad.network) {
            NetworkListService.getNetworkModelByUrl(ad.network).then(function(network) {
              scope.adNetwork = network;
            }).catch(function () {
              scope.adNetwork = null;
            })
          } else {
            scope.adNetwork = null;
          }
        }

        function checkBuildIn () {
          const buildIn = scope.buildIn = scope.tenant.info._embedded.authenticationConfiguration.buildIn;

          if (buildIn.buildinEnabled) {
            scope.buildInEnabled = true;
          } else {
            scope.buildInEnabled = false;
          }
        }

        scope.connectToAzure = function() {
          scope.gotoTab('azure');
          const activationUrl = scope.tenant.info._embedded.tenantIdentityProviders.providers.azure._links['px:tenant_activation_link'].href;
          const domainUrl = $location.absUrl().split('/admin');
          const activationUrlAndRedirect = activationUrl + domainUrl[0]  + URLS.TEST_IDENTITY_PROVIDERS;

          $http.get(activationUrlAndRedirect).then(function(response) {
            $window.open(response.data.authentication_url, '_blank')
          }).catch(function(error){})
        }

        scope.connectToGoogle = function () {
          scope.gotoTab('google');
          const activationUrl = scope.tenant.info._embedded.tenantIdentityProviders.providers.google._links['px:tenant_activation_link'].href;
          const domainUrl = $location.absUrl().split('/admin');
          const activationUrlAndRedirect = activationUrl + domainUrl[0]  + URLS.TEST_IDENTITY_PROVIDERS;

          $http.get(activationUrlAndRedirect).then(function(response) {
            $window.open(response.data.authentication_url, '_blank')
          }).catch(function(error){});
        }

        scope.gotoTab = function (tab) {
          $location.path('/authentication').search({'authenticationSection': tab});
        }

        function setListeners () {
          // IDENTITY_PROVIDER_CREATED handler lives in AuthenticationSettingsController
          // (it fires per page-load regardless of which tab is mounted).
          scope.$on('CHECK_TODO_LIST', function() {
            scope.tenant.info.todoMap = TenantListService.currentTenant.info.todoMap;
          })
        }

        scope.$on('$destroy', function() {
        });

      }
    };
  }

  pxSetupAuthentication.$inject = [
    '$filter', '$http', 'URLS', '$location',
    '$window', 'TenantListService', 'NetworkListService',
    'IDP_PROVIDERS'
  ];

  angular
    .module('printix-admin')
    .directive('pxSetupAuthentication', pxSetupAuthentication);

})();
